class MbProductCouponTimer extends HTMLElement {
  connectedCallback() {
    if (this.dataset.timerReady === 'true') return;
    this.dataset.timerReady = 'true';

    this.hours = this.querySelector('[data-product-timer-hours]');
    this.minutes = this.querySelector('[data-product-timer-minutes]');
    this.seconds = this.querySelector('[data-product-timer-seconds]');
    this.clock = this.querySelector('[data-product-timer-clock]');
    this.expired = this.querySelector('[data-product-timer-expired]');

    this.durationMinutes = Math.max(1, this.toInt('durationMinutes', 15));
    this.persistence = this.dataset.persistence || 'browser';
    this.expiredBehavior = this.dataset.expiredBehavior || 'message';
    this.coupon = (this.dataset.coupon || 'bienvenida10').trim().toLowerCase();

    if (!this.hours || !this.minutes || !this.seconds) return;

    try {
      this.storage = this.persistence === 'session' ? window.sessionStorage : window.localStorage;
    } catch (error) {
      this.storage = null;
    }

    // Chave própria da PDP: não altera o estado do popup nem do carrinho.
    this.storageKey = `marea:pdp-coupon-timer:${this.coupon}`;
    this.expiresAt = this.readExpiry();

    // Na PDP o contador começa assim que o bloco entra na página.
    if (!this.expiresAt || this.expiresAt <= Date.now()) this.createExpiry();

    this.tick();
    this.interval = window.setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.interval);
  }

  toInt(name, fallback) {
    const value = Number.parseInt(this.dataset[name] || '', 10);
    return Number.isFinite(value) ? value : fallback;
  }

  readExpiry() {
    if (!this.storage) return 0;
    try {
      const expiry = Number.parseInt(this.storage.getItem(this.storageKey) || '0', 10);
      if (!Number.isFinite(expiry) || expiry <= Date.now()) return 0;
      return expiry;
    } catch (error) {
      return 0;
    }
  }

  createExpiry() {
    this.expiresAt = Date.now() + this.durationMinutes * 60000;
    try {
      this.storage?.setItem(this.storageKey, String(this.expiresAt));
    } catch (error) {
      // O contador segue funcional mesmo quando o armazenamento é bloqueado.
    }
  }

  tick() {
    const remaining = Math.max(0, Math.ceil((this.expiresAt - Date.now()) / 1000));
    const hours = Math.floor(remaining / 3600);
    const minutes = Math.floor((remaining % 3600) / 60);
    const seconds = remaining % 60;

    this.hours.textContent = String(hours).padStart(2, '0');
    this.minutes.textContent = String(minutes).padStart(2, '0');
    this.seconds.textContent = String(seconds).padStart(2, '0');

    if (remaining > 0) return;

    window.clearInterval(this.interval);
    this.interval = null;
    this.classList.add('is-expired');

    if (this.expiredBehavior === 'hide') {
      this.hidden = true;
      return;
    }

    if (this.expiredBehavior === 'message') {
      if (this.clock) this.clock.hidden = true;
      if (this.expired) this.expired.hidden = false;
    }
  }
}

if (!customElements.get('mb-product-coupon-timer')) {
  customElements.define('mb-product-coupon-timer', MbProductCouponTimer);
}
